import { SaleType } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../components/ModuleProvider';
import { useResellerBranding } from './useResellerBranding';
const splitTime = time => {
  return {
    days: Math.floor(time / (1000 * 60 * 60 * 24)),
    hours: Math.floor(time / (1000 * 60 * 60) % 24),
    minutes: Math.floor(time / (1000 * 60) % 60),
    seconds: Math.floor(time / 1000 % 60)
  };
};
export const useSaleBannerType = () => {
  var _discountData$discoun, _discountData$discoun2, _discountData$discoun3;
  const module = useCurrentModule();
  const {
    isResellerOffering
  } = useResellerBranding();

  // use useSaleCountdown from the platform (waiting for platform release)
  const {
    data: discountData,
    isLoading: isDiscountLoading
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const saleType = discountData == null || (_discountData$discoun = discountData.discount) == null || (_discountData$discoun = _discountData$discoun.discountInfo) == null || (_discountData$discoun = _discountData$discoun.sale) == null ? void 0 : _discountData$discoun.saleType;
  const expiresAt = discountData == null || (_discountData$discoun2 = discountData.discount) == null ? void 0 : _discountData$discoun2.expiresAt;
  const timeLeft = expiresAt ? new Date(expiresAt).getTime() - new Date().getTime() : null;
  const rate = discountData == null || (_discountData$discoun3 = discountData.discount) == null ? void 0 : _discountData$discoun3.rate;
  if (isDiscountLoading || !(discountData != null && discountData.hasSale) || !rate) {
    return {
      bannerType: null,
      isLoading: isDiscountLoading
    };
  }
  const bannerType = getBannerType(isResellerOffering, saleType, timeLeft ? splitTime(timeLeft) : undefined);
  return {
    bannerType,
    isLoading: false
  };
};
function getBannerType(isResellerOffering, saleType, timeLeft) {
  // not implemented yet
  const isPermanentSale = false;

  // not implemented yet
  const isSecondUpgrade = false;
  if (isResellerOffering) {
    return 'reseller';
  }
  if (isPermanentSale) {
    return isSecondUpgrade ? 'permanent_second_upgrade' : 'permanent_initial';
  }
  if (saleType === SaleType.PERSONAL_SALE) {
    if (timeLeft) {
      if (timeLeft.days >= 2) {
        return 'personal_multi_day';
      } else if (timeLeft.days === 1) {
        return 'personal_one_day';
      } else {
        return 'personal_last_chance';
      }
    }
    return 'personal_multi_day';
  }
  const isLastDay = (timeLeft == null ? void 0 : timeLeft.days) === 0;
  if (isLastDay) {
    return 'last_day';
  }
  switch (saleType) {
    case SaleType.SEASONAL_EXTENDED:
      return 'seasonal_extended';
    case SaleType.SEASONAL_SALE:
    case SaleType.SPECIAL_DISCOUNT:
    default:
      return 'seasonal_regular';
  }
}
//# sourceMappingURL=useSaleBannerType.js.map